import { SpinButton } from "@fluentui/react";
import { useEffect, useState, type SyntheticEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { LessThanData } from "../../../api";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type LessThanNode = Node<InterfaceToRecord<LessThanData & ExtraNodeData>>;

export default function LessThan(props: NodeProps<LessThanNode>): JSX.Element {
    const [number, setNumber] = useState(props.data.number ?? 1);
    const updateNode = useUpdateNodeData<LessThanNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ number });
    }, [number, updateNode]);

    function onSpinButtonChange(
        _e: SyntheticEvent<HTMLElement, Event>,
        newValue?: string | undefined,
    ): void {
        if (!newValue) {
            return;
        }
        const newNumber = parseInt(newValue);
        setNumber(newNumber);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <SpinButton
                className={"nodrag"}
                value={number.toString()}
                onChange={onSpinButtonChange}
                min={1}
                max={100}
            />
        </ActionConfigNode>
    );
}
